import React from 'react';

const SIGNAL_STYLES = {
  High: 'bg-[#07743F] text-white',
  Medium: 'bg-[#E4E517] text-gray-900',
  Low: 'bg-gray-200 text-gray-700',
};

const SignalBadge = ({ level }) => (
  <span
    data-testid={`signal-level-${level || 'unknown'}`}
    className={`inline-block px-2 py-0.5 rounded-full text-xs font-bold ${
      SIGNAL_STYLES[level] || 'bg-gray-200 text-gray-700'
    }`}
  >
    {level || 'Unknown'}
  </span>
);

const SignalRow = ({ title, signal }) => (
  <div className="flex items-start gap-3 py-3 border-b border-gray-100 last:border-0">
    <div className="w-28 shrink-0">
      <p className="text-xs font-bold text-gray-700 uppercase tracking-wide">{title}</p>
      <SignalBadge level={signal?.level} />
    </div>
    <p className="text-sm text-gray-700 italic flex-1">{signal?.rationale || '—'}</p>
  </div>
);

export const ImpactSignals = ({ data }) => {
  if (!data) return null;
  return (
    <div data-testid="output-impact-signals" className="bg-gray-50 rounded-lg p-4">
      <SignalRow title="Youth" signal={data.youth_signal} />
      <SignalRow title="System" signal={data.system_signal} />
      <SignalRow title="Policy" signal={data.policy_signal} />
    </div>
  );
};

export const EvidenceExtraction = ({ data }) => {
  if (!data) return null;
  const rows = [
    ['Country', data.country],
    ['Theme', data.theme],
    ['Value chain', data.value_chain],
    ['Gender', data.gender],
    ['Youth type', data.youth_type],
    ['Challenge', data.challenge],
    ['Intervention', data.intervention],
    ['Outcome', data.outcome],
    ['Jobs created', data.jobs_created],
    ['Income change', data.income_change],
    ['Technology adopted', data.technology_adopted],
    ['Policy barriers', data.policy_barriers],
  ];
  return (
    <div data-testid="output-evidence-extraction">
      <table className="w-full text-sm">
        <tbody>
          {rows.map(([label, value]) => (
            <tr key={label} className="border-b border-gray-100 last:border-0">
              <td className="py-2 pr-4 text-xs font-bold text-gray-600 uppercase tracking-wide w-44 align-top">
                {label}
              </td>
              <td className="py-2 text-gray-800">{value || <span className="text-gray-400 italic">—</span>}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
